import React from 'react';
import './App.css';
import HomePage from './components/Homepage';

function App() {
    return (
        <HomePage/>
  );
}

export default App;
